<template>
  <div id="app">
    <loading :active.sync="this.$store.getters.loadingActive"
             :can-cancel="false"
             :is-full-page="true" color="#135d9a" loader="spinner"></loading>
    <div v-cloak class="main">
      <!-- Error message -->
      <prv-error-message></prv-error-message>
      <!-- View -->
      <router-view/>
    </div>
  </div>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import 'vue-search-select/dist/VueSearchSelect.css';
  import PrvErrorMessage from '@/components/common/PrvErrorMessage.vue';

  export default {
    components: {
      PrvErrorMessage,
      Loading,
    },
    data () {
      return {
        publicPath: process.env.BASE_URL
      }
    },
    computed: {
      showError() {
        return this.$store.state.error;
      },
      beforeMount() {
        this.$store.dispatch('startLoading');
      },
    }
  }
</script>

<style lang='css'>

  /** vue-search-select selection style */
  .ui.selection.dropdown .menu .item {
    font-size: 1.3rem !important;
  }

  [v-cloak] {
    display: none;
  }

</style>
